

export interface CompanyLookup {
  id: string;
  name: string;
  companyNumber: string;
}
